/* eslint-disable no-unused-vars */
import { Input, Button } from 'antd';
import './Table.scss';
import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { Select } from 'antd';

const { Option } = Select;

type Action = {
    icon?: ReactNode;
    title: string;
    action: () => void;
};
type Filter = {
    title: string;
    // eslint-disable-next-line no-unused-vars
    action: (val: string) => void;
    data: any[];
    keyProp?: string;
    valueProp?: string;
    selectedTab?:any;
    onsearch?:(val: string) => void;
};
export interface ITableHeader {
    // eslint-disable-next-line no-unused-vars
    onSearch?: (value: string) => void;
   
    actions?: Action[];
    additionalActions?: Action[];
    filters?: Filter[];
    showSearchBox: boolean;
}
const { Search } = Input;
function TableHeader(props: ITableHeader) {
    return (
        <div className="table-header" style={{padding : '0% 3%'}}>
            <div className="first-row">
                <div className="actions">
                    {props.actions?.map((a:any, index:any) => (
                        <Button key={a.title + '_' + index} type="primary" icon={a.icon} onClick={a.action}>
                            <FormattedMessage id={a.title} />
                        </Button>
                    ))}
                </div>
            </div>
            <div className="second-row">
                <div className="filters">
                    {props.filters?.map((f:any) => {
                        if(f?.selectedTab !== 'G' && f?.selectedTab !== 'O'){
                            return(<Select
                                allowClear
                                className="select"
                                key={f.title}
                                showSearch
                                placeholder={f.title}
                                optionFilterProp="children"
                                onChange={f.action}
                                onSearch={f?.onsearch}
                                // filterOption={(input, option) =>
                                //     option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                // }
                            >
                                {f.data.map((o:any) => (
                                    <Option key={o[f.keyProp || '']} value={o[f.keyProp || '']}>
                                        {o[f.valueProp || '']}
                                    </Option>
                                ))}
                            </Select>)
                        }else{
                            return false;
                        }
                    })}
                </div>
                {props.showSearchBox && (
                    <div className="search-box">
                        <Search enterButton onSearch={props.onSearch} />
                    </div>
                )}
            </div>
        </div>
    );
}
export default TableHeader;
